/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { PayOrder200ResponseDataOrder } from './PayOrder200ResponseDataOrder'
import {
  PayOrder200ResponseDataOrderFromJSON,
  PayOrder200ResponseDataOrderFromJSONTyped,
  PayOrder200ResponseDataOrderToJSON,
} from './PayOrder200ResponseDataOrder'
import type { PayOrder200ResponseDataPayment } from './PayOrder200ResponseDataPayment'
import {
  PayOrder200ResponseDataPaymentFromJSON,
  PayOrder200ResponseDataPaymentFromJSONTyped,
  PayOrder200ResponseDataPaymentToJSON,
} from './PayOrder200ResponseDataPayment'

/**
 *
 * @export
 * @interface PayOrder200ResponseData
 */
export interface PayOrder200ResponseData {
  /**
   *
   * @type {PayOrder200ResponseDataOrder}
   * @memberof PayOrder200ResponseData
   */
  order: PayOrder200ResponseDataOrder
  /**
   *
   * @type {PayOrder200ResponseDataPayment}
   * @memberof PayOrder200ResponseData
   */
  payment?: PayOrder200ResponseDataPayment
}

/**
 * Check if a given object implements the PayOrder200ResponseData interface.
 */
export function instanceOfPayOrder200ResponseData(
  value: object
): value is PayOrder200ResponseData {
  if (!('order' in value) || value['order'] === undefined) return false
  return true
}

export function PayOrder200ResponseDataFromJSON(
  json: any
): PayOrder200ResponseData {
  return PayOrder200ResponseDataFromJSONTyped(json, false)
}

export function PayOrder200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PayOrder200ResponseData {
  if (json == null) {
    return json
  }
  return {
    order: PayOrder200ResponseDataOrderFromJSON(json['order']),
    payment:
      json['payment'] == null
        ? undefined
        : PayOrder200ResponseDataPaymentFromJSON(json['payment']),
  }
}

export function PayOrder200ResponseDataToJSON(
  value?: PayOrder200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    order: PayOrder200ResponseDataOrderToJSON(value['order']),
    payment: PayOrder200ResponseDataPaymentToJSON(value['payment']),
  }
}
